import { APP_ROUTES } from './route.constant';

export interface AdminMenuItem {
  label: string;
  route: string;
  icon: AdminMenuIcon;
  description: string;
}

export type AdminMenuIcon =
  | 'dashboard'
  | 'enterprises'
  | 'incomplete'
  | 'plans'
  | 'features'
  | 'templates'
  | 'lead-capture'
  | 'reports';

export const ADMIN_MENU_ITEMS: AdminMenuItem[] = [
  {
    label: 'Dashboard',
    route: APP_ROUTES.ADMIN.DASHBOARD,
    icon: 'dashboard',
    description: 'Overview of platform activity and key metrics.',
  },
  {
    label: 'Enterprises',
    route: APP_ROUTES.ADMIN.ENTERPRICES.ROOT,
    icon: 'enterprises',
    description: 'Manage enterprise accounts and organizations.',
  },
  {
    label: 'Incomplete Enterprises',
    route: APP_ROUTES.ADMIN.ENTERPRICES.INCOMPLETE,
    icon: 'incomplete',
    description: 'Track enterprises with pending onboarding steps.',
  },
  {
    label: 'Plans',
    route: APP_ROUTES.ADMIN.PLANS.ROOT,
    icon: 'plans',
    description: 'Configure subscription plans and pricing tiers.',
  },
  {
    label: 'Features',
    route: APP_ROUTES.ADMIN.FEATURES.ROOT,
    icon: 'features',
    description: 'Manage platform features and entitlements.',
  },
  {
    label: 'Templates',
    route: APP_ROUTES.ADMIN.TEMPLATES.ROOT,
    icon: 'templates',
    description: 'Manage inquiry and questionnaire templates.',
  },
  {
    label: 'Lead Capture',
    route: APP_ROUTES.ADMIN.LEAD_CAPTURE.ROOT,
    icon: 'lead-capture',
    description: 'Review submitted inquiry responses and captured leads.',
  },
  {
    label: 'Reports',
    route: APP_ROUTES.ADMIN.REPORTS,
    icon: 'reports',
    description: 'View analytics and operational reports.',
  },
];
